import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import BreederNewsLayoutContainer from 'dpl/breeder_news/containers/LayoutContainer';
import GlobalMobileMenuNavigationMenu from 'dpl/components/GlobalMobileMenu/GlobalMobileMenuNavigationMenu';
import GlobalMobileMenuSearchMenu from 'dpl/components/GlobalMobileMenu/GlobalMobileMenuSearchMenu';
import MobileMenu from 'dpl/components/MobileMenu';
import { MENU_TYPES } from 'dpl/decorators/withMobileMenu';

export default function GlobalMobileMenu({
  closeMenu,
  currentUser,
  isLoggedIn,
  openMobileMenuName: initialOpenMobileMenuName,
  selectedSearchType,
  notifications,
  openSearchBreedersMenu,
  openSearchSheltersMenu,
  onChange
}) {
  const [openMobileMenuName, setOpenMobileMenuName] = useState(null);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const searchIsShown = openMobileMenuName === MENU_TYPES.SEARCH;
  const navigationIsShown = openMobileMenuName === MENU_TYPES.NAVIGATION;
  const breederNewsIsShown = openMobileMenuName === MENU_TYPES.BREEDER_NEWS;
  const isOpen = Boolean(openMobileMenuName);

  useEffect(() => {
    setIsTransitioning(true);
  }, [isOpen]);

  useEffect(() => {
    setOpenMobileMenuName(initialOpenMobileMenuName);
  }, [initialOpenMobileMenuName]);

  useEffect(() => {
    if (openMobileMenuName !== initialOpenMobileMenuName) {
      onChange?.(openMobileMenuName);
    }
  }, [openMobileMenuName, initialOpenMobileMenuName]);

  return (
    <MobileMenu
      className={classnames('GlobalMobileMenu', {
        'GlobalMobileMenu--breederNews': breederNewsIsShown
      })}
      isOpen={isOpen}
      position="top"
      zIndex={isOpen ? '0' : '-1'}
      onTransitionEnd={() => setIsTransitioning(false)}
    >
      <MobileMenu
        className="GlobalMobileMenu__subMenu"
        disableTransition={isTransitioning}
        position={isOpen ? 'left' : 'top'}
        isOpen={searchIsShown}
      >
        <GlobalMobileMenuSearchMenu
          isOpen={searchIsShown}
          selectedSearchType={selectedSearchType}
          openSearchBreedersMenu={openSearchBreedersMenu}
          openSearchSheltersMenu={openSearchSheltersMenu}
        />
      </MobileMenu>
      <MobileMenu
        className="GlobalMobileMenu__subMenu"
        disableTransition={isTransitioning}
        position={isOpen ? 'right' : 'top'}
        isOpen={navigationIsShown}
      >
        <GlobalMobileMenuNavigationMenu
          currentUser={currentUser}
          isLoggedIn={isLoggedIn}
          onClose={closeMenu}
          notifications={notifications}
        />
      </MobileMenu>
      {isLoggedIn && currentUser.value.data.breeder && (
        <MobileMenu
          className="GlobalMobileMenu__subMenu"
          disableTransition={isTransitioning}
          position={isOpen ? 'left' : 'top'}
          isOpen={breederNewsIsShown}
        >
          <BreederNewsLayoutContainer />
        </MobileMenu>
      )}
    </MobileMenu>
  );
}

GlobalMobileMenu.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    logout: PropTypes.func,
    value: PropTypes.shape({
      data: PropTypes.shape({
        buyer: PropTypes.bool,
        breeder_profile_id: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]),
        breeder: PropTypes.bool,
        profile_url: PropTypes.string
      })
    })
  }).isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  openMobileMenuName: PropTypes.string,
  selectedSearchType: PropTypes.string,
  notifications: PropTypes.object.isRequired,
  openSearchBreedersMenu: PropTypes.func.isRequired,
  openSearchSheltersMenu: PropTypes.func.isRequired,
  onChange: PropTypes.func
};

GlobalMobileMenu.defaultProps = {
  openMobileMenuName: null,
  selectedSearchType: null,
  onChange: null
};
